export const CUSTOMER_ACQUISITION_2018 = 'CUSTOMER_ACQUISITION_2018';

export default (state) => state.user.features && state.user.features.includes(CUSTOMER_ACQUISITION_2018);
